import { useMe } from '../api/auth.js';
import {
  SessionsCard,
  TwoFactorCard,
  TwoFactorPolicyCard,
} from '../components/account-security.js';
import { PageHeader } from '../components/ui.js';

/** Panel self-service security: 2FA, sessions, and (admins) the 2FA policy. */
export function SecurityPage() {
  const me = useMe();
  const isAdmin = me.data?.role === 'admin';

  return (
    <div>
      <PageHeader
        title="Security"
        description="Two-factor authentication and active sessions for your account."
      />
      <div className="space-y-6">
        <TwoFactorCard />
        <SessionsCard />
        {isAdmin && <TwoFactorPolicyCard />}
      </div>
    </div>
  );
}
